"use strict";

exports.__esModule = true;
exports.getRequiredContextsInElement = getRequiredContextsInElement;
var _getWidget = require("./getWidget");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Find all required contexts in the given element.
 */
function getRequiredContextsInElement(widgets, subject) {
  var required = [];
  var widget = (0, _getWidget.getWidgetOrThrow)(widgets, subject.type);
  var supplied = [].concat(widget.suppliesContexts);
  collectUnresolvedContexts(widgets, subject, supplied, required);
  return required;
}
function collectUnresolvedContexts(widgets, subject, supplied, required) {
  if (supplied === void 0) {
    supplied = [];
  }
  if (required === void 0) {
    required = [];
  }
  var widget = (0, _getWidget.getWidgetOrThrow)(widgets, subject.type);
  for (var _iterator = _createForOfIteratorHelperLoose(widget.requiresContexts), _step; !(_step = _iterator()).done;) {
    var name = _step.value;
    if (!supplied.includes(name) && !required.includes(name)) {
      required.push(name);
    }
  }
  if (widget.isParent) {
    if (!subject.children) {
      throw new Error("children array must be initialized on a new widget if it's a parent");
    }
    for (var _iterator2 = _createForOfIteratorHelperLoose(subject.children), _step2; !(_step2 = _iterator2()).done;) {
      var child = _step2.value;
      collectUnresolvedContexts(widgets, child, supplied, required);
    }
  }
}